import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { UtilService } from 'src/app/services/util.service';
import { localStorageKeys } from '../const/enum';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {

  constructor(
    private router: Router,
    private utils: UtilService,
  ) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.utils.getLocalStorage(localStorageKeys.accessToken)) {
      return true;
    }
    this.router.navigate(['/login']);
    return false;
  }
}
